/** DataBest — Dashboard API. */
import api from "@/lib/axios";

const params = (from, to, extra = {}) => ({
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...extra,
});

export const dashboardApi = {
    kpis: ({ from, to, individual_id, life_area } = {}) =>
        api.get("/dashboard/kpis", {
            params: params(from, to, { individual_id, life_area }),
        }).then((r) => r.data),

    radar: ({ from, to, individual_id, life_area } = {}) =>
        api.get("/dashboard/radar", {
            params: params(from, to, { individual_id, life_area }),
        }).then((r) => r.data),

    trend: ({ from, to, granularity, individual_id, life_area } = {}) =>
        api.get("/dashboard/trend", {
            params: params(from, to, { granularity, individual_id, life_area }),
        }).then((r) => r.data),

    breakdown: ({ from, to, group_by, individual_id, life_area } = {}) =>
        api.get("/dashboard/breakdown", {
            params: params(from, to, { group_by, individual_id, life_area }),
        }).then((r) => r.data),
};
